import { useQuery } from "@tanstack/react-query";

import { getReferrer } from "services";

import { DEFAULT_CACHE_TIME, GET_REFERRER } from "consts";

export const useGetReferrerByToken = (referralToken: string) =>
  useQuery({
    queryKey: [GET_REFERRER, referralToken],
    queryFn: () => getReferrer({ referralToken }),
    gcTime: DEFAULT_CACHE_TIME * 7,
    staleTime: DEFAULT_CACHE_TIME * 7,
    enabled: referralToken !== "",
  });
